// extracted by mini-css-extract-plugin
module.exports =  {"sectionBody":"sectionBody__hWh9K"};